(window.BWVideoTabs = function ($, Behaviors) {
    "use strict";

    const module = {};

    function BWVideoTabs() {
        const videoSections = document.querySelectorAll('.bw-video-tabs-section');

        if (!videoSections) {return;}

        function loadVideoOnClick() {


            videoSections.forEach(section => {

                const videos = section.querySelectorAll('.bw-video');

                if (!videos) {return;}

                videos.forEach(video => {
                    if (!video.dataset.bwVideoId) {return false;}

                    const overlay = video.querySelector('.bw-video-overlay');

                    overlay.addEventListener('click', () => {

                        try {
                            const videoContainer = video.querySelector('.bw-video-container');
                            const videoId = video.dataset.bwVideoId;
                            const isVimeo = video.dataset.bwVideoType === 'vimeo';
                            const isYouTube = video.dataset.bwVideoType === 'youtube';

                            if (isVimeo && typeof Vimeo !== 'undefined') {
                                const player = new Vimeo.Player(videoContainer, {
                                    id: videoId,
                                    controls: true,
                                });

                                player.ready().then(()=>{
                                    player.play();

                                    player.on('play', () => {
                                        overlay.style.opacity = 0;
                                        setTimeout(() => {
                                            overlay.style.display = 'none';
                                        }, 600);
                                    });
                                }).catch((error) => {
                                    console.error('Vimeo player error:', error);

                                });

                            } else if (isYouTube) {
                                const player = new YT.Player(videoContainer, {
                                    height: '100%',
                                    width: '100%',
                                    videoId: videoId,
                                    playerVars: {
                                        'controls': 0
                                    },
                                    events: {
                                        'onReady': (event) => {
                                            event.target.playVideo();
                                        },
                                        'onStateChange': (event) => {
                                            if (event.data === YT.PlayerState.PLAYING) {
                                                overlay.style.opacity = 0;
                                                setTimeout(() => {
                                                    overlay.style.display = 'none';
                                                }, 600);
                                            }
                                        },
                                        'onError': (event) => {
                                            console.error('YouTube player error:', event);
                                        }
                                    },
                                });
                            }
                        } catch (e) {
                            console.log(e);
                        }

                    });
                });
            });
        }

        function toggleVideos() {
            videoSections.forEach(section => {
                const tabs = section.querySelector('.bw-video-tabs ul');

                tabs.addEventListener('click', e => {
                    const {target} = e;

                    if (!target.matches('li')) {
                        return;
                    }

                    tabs.querySelectorAll('li').forEach(li => {
                        li.classList.remove('active');
                    });

                    target.classList.add('active');


                    const category = target.dataset.bwVideoIndex;

                    const allVideos = section.querySelectorAll('.bw-video-holder');


                    if (category === 'all') {
                        allVideos.forEach(video => {
                            video.style.display = 'block';
                        });
                        return;
                    } else {
                        allVideos.forEach(video => {
                            video.style.display = 'none';
                        });
                    }

                    const selectedVideos = section.querySelectorAll(`.bw-video-holder[data-bw-video-index="${category}"]`);

                    selectedVideos.forEach(activeVideo => {
                       activeVideo.style.display = 'block';
                    });

                });
            });
        }

        loadVideoOnClick();
        toggleVideos();
    }

    document.addEventListener('DOMContentLoaded', () => {
        BWVideoTabs();
    });

    return module;

}(window.jQuery, window.Behaviors));

